<template>
  <BaseImageUpload v-bind="style"
                   v-on="$listeners"
                   :maxSizeKB="maxSizeKB + 1"
                   :resetTrigger="resetTrigger"
                   :style="style"
                   :uploadedFile="uploadedFile"
                   :uploadingFile="uploadingFile"
                   @reset-form="resetData"
                   @select-invalid-file="selectInvalidFile"
                   @select-valid-file="selectValidFile">
    <template v-slot:content-waiting>
      <div :style="textContainerStyle">
        <div>
          Drag and drop image file here.
          File size must be less than or equal to {{ maxSize }}.
        </div>
        <div v-if="error"
             :style="errorTextContainerStyle">
          {{ error }}
        </div>
      </div>
    </template>
    <template v-slot:content-file-selected>
      <div :style="imageContainerStyle">
        <UserImage :src="payload.url"
                   :style="imageStyle" />
        <div :style="fileNameStyle">
          {{ payload.file.name }}
        </div>
        <div :style="fileSizeStyle">
          {{ Math.ceil(payload.file.size * 10 / 1000) / 10 }} KB
        </div>
        <div :style="buttonContainerStyle">
          <ButtonPrimary :style="buttonStyle"
                         @click.prevent="$emit('upload-file', payload)">
            Upload
          </ButtonPrimary>
        </div>
      </div>
    </template>
    <template v-slot:content-uploading>
      <LoaderPrimary :loading="true" />
    </template>
  </BaseImageUpload>
</template>

<script>
  import BaseImageUpload from '@base/base-image-upload'
  import ButtonPrimary from '@modules/button/button-primary'
  import LoaderPrimary from '@modules/loader/loader-primary'
  import UserImage from '@modules/image/user-image'
  import { FontStyle, Layout } from '@js/styles'
  import { mapGetters } from 'vuex'

  export default {
    name: 'ImageUploadPrimary',
    inheritAttrs: false,
    components: {
      BaseImageUpload,
      ButtonPrimary,
      LoaderPrimary,
      UserImage,
    },
    props: {
      maxSizeKB: { type: Number, required: false, default: 1000 },
      resetTrigger: { type: Boolean, required: false, default: false },
      uploadedFile: { type: Boolean, required: false, default: false },
      uploadingFile: { type: Boolean, required: false, default: false },
    },
    data: function () {
      return {
        buttonContainerStyle: {
          margin: `${Layout.space.md} 0 0 0`,
        },
        buttonStyle: {
          minWidth: '84px',
        },
        error: '',
        errorTextContainerStyle: {
          fontSize: FontStyle.size.sm,
          fontWeight: FontStyle.weight.md,
        },
        fileNameStyle: {
          fontSize: FontStyle.size.md,
          fontWeight: FontStyle.weight.lg,
        },
        fileSizeStyle: {
          fontSize: FontStyle.size.sm,
          fontWeight: FontStyle.weight.md,
        },
        imageContainerStyle: {
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          justifyContent: 'center',
          width: '100%',
        },
        imageStyle: {
          height: '128px',
          width: '128px',
        },
        innerContainerStyle: {},
        inputStyle: {
          cursor: {
            '': 'pointer',
            disabled: 'default',
          },
          zIndex: 99,
        },
        payload: null,
        style: {
          cursor: {
            '': 'pointer',
            disabled: 'default',
          },
        },
        textContainerStyle: {
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          fontSize: FontStyle.size.md,
          fontWeight: FontStyle.weight.md,
          height: '100%',
          justifyContent: 'center',
          textAlign: 'center',
          width: '100%',
        },
      };
    },
    created: function () {
      this.errorTextContainerStyle = {
        ...this.errorTextContainerStyle,
        color: this.color.warning1(),
      };

      this.innerContainerStyle = {
        ...this.innerContainerStyle,
        border: `dashed ${this.color.dark2()}`,
        borderWidth: '1px',
      };

      this.inputStyle = {
        ...this.inputStyle,
      };

      this.style = {
        ...this.style,
        backgroundColor: {
          '': this.color.background1(0.25),
          hover: this.color.action1(0.25),
          selected: this.color.action1(1),
        },
        innerContainerStyle: this.innerContainerStyle,
        inputStyle: this.inputStyle,
        padding: Layout.space.sm,
      };

      this.textStyle = {
        ...this.textStyle,
        color: this.color.dark2(),
      };
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
      maxSize: function () {
        return this.maxSizeKB >= 1000 ? `${this.maxSizeKB / 1000}MB` : `${this.maxSizeKB}KB`;
      },
    },
    methods: {
      resetData: function () {
        this.error = '';
        this.payload = null;
        this.uploadedFile = false;
        this.uploadingFile = false;
      },
      selectInvalidFile: function () {
        this.error = 'Invalid file is selected.';
      },
      selectValidFile: function (payload) {
        this.payload = payload;
      },
    },
  };
</script>
